import React from "react"
import { DrawerCategory, DrawerSection } from "../../Drawer/DrawerItems"
import { Typography } from "@material-ui/core"
import api from "../../../services/api"
import LoadingSpinner from "../../misc/LoadingSpinner"
import WarningTypography from "../../WarningTypography"
import ReactJson from "react-json-view"
import copy from "copy-to-clipboard"
import CopyableText from "../../misc/copyableText"

interface MovementMetadataProps {
  movementId: string
}

const MovementMetadata = (props: MovementMetadataProps): JSX.Element => {
  const metadata = api.backOffice.wallet.useMovementMetadata(props.movementId)

  if (metadata.isLoading || !metadata.data) {
    return (
      <DrawerCategory title="Tech administrator information">
        <LoadingSpinner />
      </DrawerCategory>
    )
  }

  if (metadata.isError) {
    return (
      <DrawerCategory title="Tech administrator information">
        <WarningTypography>Failed to load tech administrator information</WarningTypography>
      </DrawerCategory>
    )
  }

  return (
    <DrawerCategory title="Tech administrator information">
      <DrawerSection name="Metadata">
        <ReactJson
          displayDataTypes={false}
          displayObjectSize={false}
          name={"movement"}
          src={metadata.data.metadata}
          enableClipboard={(props) => copy(JSON.stringify(props.src, null, 2))}
          collapsed={true}
        />
      </DrawerSection>
      <DrawerSection name="Created at">
        <Typography variant="body2" color="textSecondary">
          <CopyableText>{metadata.data.createdAt}</CopyableText>
        </Typography>
      </DrawerSection>
    </DrawerCategory>
  )
}

export default MovementMetadata
